import { render, staticRenderFns } from "./QuestionCriteriaComponent.vue?vue&type=template&id=41479bbe"
import script from "./QuestionCriteriaComponent.vue?vue&type=script&lang=js"
export * from "./QuestionCriteriaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports